import ImageCDN from "@components/skeleton/ImageCDN";
import MediaAssets from "@components/utils/MediaAssets";

const LayoutBSuccessScreen = (): JSX.Element => {
  return (
    <>
      <div className="fixed left-0 top-0 z-[-100] w-full desktop:static">
        <div className="relative overflow-hidden bg-blue-5 pt-12 desktop:rounded-t-3xl">
          <div className="flex h-[16.125rem] justify-center desktop:h-[11.25rem]">
            <ImageCDN
              src={MediaAssets.getAsset("success_screen_background")}
              width="540"
              height="270"
              objectFit="cover"
              alt="success screen background"
            />
          </div>
        </div>
      </div>
      <div className="mx-auto mt-[13rem] w-[90%] text-center desktop:my-12">
        <h4 id="submit-thank-you" className="text-h4 font-semibold">
          Thank you for your inquiry!
        </h4>
        <p className="mb-[3.125rem] mt-3 text-p14 font-medium desktop:text-p">
          One of our travel experts will get back to you within an hour. For
          even faster service call us.
        </p>
      </div>
    </>
  );
};

export default LayoutBSuccessScreen;
